/* G1 chrome (Pergolux P0, 5 Oct 2026). Deferred; loaded right before snippets/woodlit-chat.liquid.
   Modules: office-hours keeper, tel normaliser and tap binder (R02, R09), chat triggers (R09),
   60-Day anchor fallback (R19), float manager (R05), top bar (R19).
   Each module is guarded so one failure never stops the others. */

/* F5: keep the office-hours state current (the head script set it before first paint). */
(function () {
  try {
    var WL = window.WL;
    if (!WL || typeof WL.applyHours !== 'function') return;
    setInterval(WL.applyHours, 60000);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) WL.applyHours(); });
  } catch (e) {}
})();

/* R09 tel normaliser and R02 tap binder: tel_tap, whatsapp_tap, email_tap with the nearest data-wl-placement. */
(function () {
  try {
    var cleanTel = function (a) {
      var h = a.getAttribute('href') || '';
      if (!/^tel:/i.test(h)) return;
      var raw = h.slice(4);
      try { raw = decodeURIComponent(raw); } catch (e) {}
      var c = raw.replace(/[^\d+]/g, '');
      c = c.charAt(0) + c.slice(1).replace(/\+/g, '');
      if (c && 'tel:' + c !== h) a.setAttribute('href', 'tel:' + c);
    };
    var normAll = function () {
      var n = document.querySelectorAll('a[href^="tel:"], a[href^="TEL:"], a[href^="Tel:"]');
      for (var i = 0; i < n.length; i++) cleanTel(n[i]);
    };
    if (document.readyState !== 'loading') normAll(); else document.addEventListener('DOMContentLoaded', normAll);
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      var h = a.getAttribute('href') || '';
      if (/^tel:/i.test(h)) { cleanTel(a); h = a.getAttribute('href') || ''; }
      if (typeof window.wlTrack !== 'function') return;
      var host = a.closest('[data-wl-placement]');
      var pl = host ? host.getAttribute('data-wl-placement')
        : a.closest('.wl-tb') ? 'topbar' : a.closest('#cart-drawer') ? 'drawer' : a.closest('.cart[data-cart-page]') ? 'cart_page'
        : a.closest('header-drawer') ? 'menu' : a.closest('.footer-sections, footer') ? 'footer' : 'page';
      if (/^tel:/i.test(h)) window.wlTrack('tel_tap', { placement: pl });
      else if (/wa\.me\/|api\.whatsapp\.com|^whatsapp:/i.test(h)) window.wlTrack('whatsapp_tap', { placement: pl });
      else if (/^mailto:/i.test(h)) window.wlTrack('email_tap', { placement: pl });
    }, true);
  } catch (e) {}
})();

/* R09 chat triggers: [data-wl-chat] links open the chat (window.wlOpenChat from woodlit-chat); without it they go to the contact page. */
(function () {
  try {
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest && e.target.closest('[data-wl-chat]');
      if (!t || typeof window.wlOpenChat !== 'function') return;
      e.preventDefault();
      var host = t.closest('[data-wl-placement]'), pl = host ? host.getAttribute('data-wl-placement') : 'page';
      var sheet = t.closest('dialog.wl-cs'); if (sheet && sheet.open) sheet.close();
      var dr = document.querySelector('header-drawer.is-open');
      if (dr) { dr.dispatchEvent(new CustomEvent('theme:drawer:close', { bubbles: true })); setTimeout(function () { window.wlOpenChat(pl); }, 320); }
      else window.wlOpenChat(pl);
    });
  } catch (e) {}
})();

/* R19 60-Day Guarantee anchor fallback on the warranty page (page id gate), until the page body carries the id. */
(function () {
  try {
    var WL = window.WL || {}, ID = 'sixty-day-guarantee';
    if (WL.pageId !== 177743987026) return;
    var go = function () {
      if (location.hash !== '#' + ID || document.getElementById(ID)) return;
      var hs = document.querySelectorAll('.rte h2, .rte h3');
      for (var i = 0; i < hs.length; i++) {
        if (/60/.test(hs[i].textContent || '')) { hs[i].id = ID; hs[i].scrollIntoView(); return; }
      }
    };
    if (document.readyState !== 'loading') go(); else document.addEventListener('DOMContentLoaded', go);
    window.addEventListener('hashchange', go);
  } catch (e) {}
})();

/* R05 float manager: lifts the chat above any visible bottom bar, hides launcher, bubble, teaser and back-to-top
   while a drawer, dialog, photo viewer or the consent banner is open, and yields to [data-wl-avoid-float] controls.
   Fade-ins and fade-outs (Klaviyo popups are inserted at opacity 0 and fade with CSS animations) are followed through
   animation and transition events, a short settle after every DOM insertion, and a light poll while an overlay is open,
   so the state never waits for a scroll (browser QA pass 1, home F2 and collection F1). A dialog that is fading out to
   opacity 0 counts as closed, so the chat and the teaser come back while it fades, as on the live theme.
   Avoid zones (browser QA pass 2, Family Play F1/F2 and cart F1): [data-wl-avoid-float] plus, so the zones hold whatever
   markup the owning groups ship, the fields and buttons of the two Family Play quote forms (PDP #family-quote-form,
   collection #fpc-quote-form) and every block of the /cart summary column (terms, Check out, wallets, help line, bank
   line, marks, notes).
   The launcher fades while it overlaps a zone (html.wl-float-yield) and so does the Klaviyo teaser (html.wl-teaser-yield).
   Round 6 (browser QA pass 3, Kids Play PDP F1 and Family Play F1): a bottom bar lifts the chat from the frame its class
   turns on (layout height, not the faded and translated box, so the launcher no longer waits for the bar's fade-in), and
   keeps the lift while the bar is still on screen fading out and for 250 ms after its class goes off, so a bar that
   flickers off and on does not make the chat jump; the launcher yield also tests the place the launcher is gliding to,
   so it fades before it slides over a zone; the theme back-to-top button yields to the same zones
   (html.wl-btt-yield), measured at its resting place so it never shows over a zone while it slides in. */
(function () {
  try {
    var html = document.documentElement;
    var BAR_SEL = '#cart-bar, #fpc-sticky, [data-wl-bottom-bar]';
    var CONSENT_SEL = '#shopify-pc__banner';
    var WL_TEASER = 'kl-teaser-';
    var BTT_SEL = '[data-scroll-top-button]';
    var FORM_CTRL = function (f) { return f + ' input:not([type="hidden"]), ' + f + ' select, ' + f + ' textarea, ' + f + ' button'; };
    var AVOID_SEL = '[data-wl-avoid-float], ' + FORM_CTRL('form#family-quote-form') + ', ' + FORM_CTRL('form#fpc-quote-form') + ', [data-cart-page] .cart__aside .cart-block';
    var hiddenByUs = false, queued = false, needTag = true, last = {}, settleT = [], pollT = 0, flagAt = 0, flagLift = 0, holdT = 0;
    var shown = function (el) {
      if (!el || !el.isConnected) return false;
      var cs = getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return false;
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < innerHeight && r.right > 0 && r.left < innerWidth;
    };
    var fadingOut = function (el) {
      try {
        var an = el.getAnimations ? el.getAnimations() : [];
        for (var i = 0; i < an.length; i++) {
          if (an[i].playState !== 'running') continue;
          var k = an[i].effect && an[i].effect.getKeyframes ? an[i].effect.getKeyframes() : [];
          if (k.length && k[k.length - 1].opacity !== undefined && parseFloat(k[k.length - 1].opacity) === 0) return true;
        }
      } catch (e) {}
      return false;
    };
    var barFlag = function (el) {
      if (el.id === 'cart-bar') return el.classList.contains('is-visible') || el.matches(':focus-within');
      if (el.id === 'fpc-sticky') return el.classList.contains('fpc-on');
      return el.classList.contains('is-visible') || el.getAttribute('data-wl-visible') === 'true';
    };
    var laidOut = function (el) {
      if (!el || !el.isConnected) return false;
      var cs = getComputedStyle(el);
      return cs.display !== 'none' && cs.visibility !== 'hidden' && el.offsetHeight > 0;
    };
    var barH = function (el) { return el.offsetHeight || Math.round(el.getBoundingClientRect().height); };
    var overlayOpen = function () {
      if (html.classList.contains('wl-pswp-open')) return true;
      if (document.querySelector('.drawer.is-open, dialog[open]')) return true;
      var m = document.querySelectorAll('[role="dialog"][aria-modal="true"], ' + CONSENT_SEL);
      for (var i = 0; i < m.length; i++) if (shown(m[i]) && !fadingOut(m[i])) return true;
      return false;
    };
    var tagTeaser = function () {
      var n = document.querySelectorAll('[class*="' + WL_TEASER + '"]');
      for (var i = 0; i < n.length; i++) {
        var el = n[i];
        if (el.classList.contains('wl-kl-teaser') || (el.parentElement && el.parentElement.closest('.wl-kl-teaser'))) continue;
        if (getComputedStyle(el).position === 'fixed') el.classList.add('wl-kl-teaser');
      }
    };
    var launcherEl = function () {
      var l = document.getElementById('wl-chat-launcher');
      if (l && !l.hidden) return l;
      return document.querySelector('.woot-widget-bubble');
    };
    var zoneHit = function (a, z) {
      for (var i = 0; i < z.length; i++) {
        var r = z[i].getBoundingClientRect();
        if (r.width && r.height && r.left < a.right && r.right > a.left && r.top < a.bottom && r.bottom > a.top) return true;
      }
      return false;
    };
    var yieldNow = function (z, lift) {
      var l = launcherEl(); if (!l) return false;
      var a = l.getBoundingClientRect(); if (!a.width) return false;
      if (zoneHit(a, z)) return true;
      // while the launcher glides to a new lift, also test where it is going, so it never slides over a zone visibly
      var d = (parseFloat(getComputedStyle(l).bottom) || 0) - (16 + lift);
      return Math.abs(d) >= 1 && zoneHit({ left: a.left, right: a.right, top: a.top + d, bottom: a.bottom + d }, z);
    };
    var restRect = function (el) {
      var r = el.getBoundingClientRect(), dx = 0, dy = 0;
      try { var t = getComputedStyle(el).transform; if (t && t !== 'none' && window.DOMMatrixReadOnly) { var m = new DOMMatrixReadOnly(t); dx = m.m41; dy = m.m42; } } catch (e) {}
      return { left: r.left - dx, right: r.right - dx, top: r.top - dy, bottom: r.bottom - dy, width: r.width, height: r.height };
    };
    var bttYield = function (z) {
      var b = document.querySelector(BTT_SEL);
      if (!b || getComputedStyle(b).display === 'none') return false;
      var a = restRect(b);
      return !!(a.width && a.height && zoneHit(a, z));
    };
    var teaserYield = function (z) {
      var t = document.querySelectorAll('.wl-kl-teaser');
      for (var i = 0; i < t.length; i++) {
        var a = t[i].getBoundingClientRect();
        if (a.width && a.height && zoneHit(a, z)) return true;
      }
      return false;
    };
    var set = function (cls, on) { if (last[cls] !== on) { last[cls] = on; html.classList.toggle(cls, on); } };
    var update = function () {
      queued = false;
      if (needTag) { needTag = false; tagTeaser(); }
      var lift = 0, flag = 0, now = Date.now();
      var bars = document.querySelectorAll(BAR_SEL);
      for (var i = 0; i < bars.length; i++) {
        if (barFlag(bars[i]) && laidOut(bars[i])) flag = Math.max(flag, barH(bars[i]));
        else if (shown(bars[i])) lift = Math.max(lift, barH(bars[i]));
      }
      lift = Math.max(lift, flag);
      // a bar whose class goes off and on again within a few frames keeps the chat where it is (no jump)
      if (flag) { flagAt = now; flagLift = flag; }
      else if (lift < flagLift && now - flagAt < 250) { lift = flagLift; clearTimeout(holdT); holdT = setTimeout(schedule, 260 - (now - flagAt)); }
      if (last.lift !== lift) { last.lift = lift; html.style.setProperty('--wl-float-lift', lift + 'px'); }
      set('wl-chat-raised', lift > 0);
      var open = overlayOpen();
      set('wl-overlay-open', open);
      if (open && !pollT) poll();
      var zones = open ? [] : document.querySelectorAll(AVOID_SEL);
      set('wl-float-yield', !open && yieldNow(zones, lift));
      set('wl-teaser-yield', !open && teaserYield(zones));
      set('wl-btt-yield', !open && bttYield(zones));
      set('wl-hide-desktop-teaser', !!(window.WL && window.WL.flags && window.WL.flags.hide_desktop_teaser));
      var cw = window.$chatwoot;
      if (cw && typeof cw.toggleBubbleVisibility === 'function') {
        if (open && !hiddenByUs) { cw.toggleBubbleVisibility('hide'); hiddenByUs = true; }
        else if (!open && hiddenByUs) { cw.toggleBubbleVisibility('show'); hiddenByUs = false; }
      }
    };
    var schedule = function () { if (!queued) { queued = true; requestAnimationFrame(update); } };
    var settle = function () {
      schedule();
      for (var i = 0; i < settleT.length; i++) clearTimeout(settleT[i]);
      settleT = [setTimeout(schedule, 150), setTimeout(schedule, 450), setTimeout(schedule, 900)];
    };
    var poll = function () {
      clearTimeout(pollT); pollT = 0;
      if (last['wl-overlay-open']) pollT = setTimeout(function () { schedule(); poll(); }, 300);
    };
    var onBodyChange = function () { needTag = true; settle(); };
    var init = function () {
      new MutationObserver(onBodyChange).observe(document.body, { childList: true, subtree: true });
      var mo = new MutationObserver(schedule);
      mo.observe(html, { attributes: true, attributeFilter: ['class'] });
      var watch = document.querySelectorAll(BAR_SEL + ', .drawer');
      for (var i = 0; i < watch.length; i++) mo.observe(watch[i], { attributes: true, attributeFilter: ['class', 'open', 'data-wl-visible', 'style'] });
      ['theme:scroll:lock', 'theme:scroll:unlock', 'theme:cart-drawer:open', 'theme:cart-drawer:close', 'visitorConsentCollected'].forEach(function (ev) {
        document.addEventListener(ev, function () { requestAnimationFrame(schedule); });
      });
      ['animationstart', 'animationend', 'animationcancel', 'transitionend', 'transitioncancel', 'focusin', 'focusout'].forEach(function (ev) {
        document.addEventListener(ev, schedule, true);
      });
      window.addEventListener('chatwoot:ready', schedule);
      window.addEventListener('resize', schedule, { passive: true });
      window.addEventListener('scroll', schedule, { passive: true });
      schedule();
    };
    if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
    window.WL = window.WL || {};
    window.WL.floats = { update: update };
  } catch (e) {}
})();

/* R19 top bar: mobile rotation (stops for good on touch, click or focus; rests on message 1 after three cycles;
   pauses on hover and in a hidden tab; message 1 only with reduced motion) and the desktop fit routine
   (the first reason long, then short, then the compact right block without hours, then the other reasons).
   The first reason is reason 1; on Family Play pages, where reasons 1 and 2 are not rendered, it is reason 3 with its
   short form, so the hours leave the bar before the reason does (browser QA pass 2, Family Play F3). */
(function () {
  try {
    var bar = document.querySelector('[data-wl-topbar]'); if (!bar) return;
    var inner = bar.querySelector('.wl-tb__in'), list = bar.querySelector('[data-wl-tb-list]');
    if (!inner || !list) return;
    var mqM = matchMedia('(max-width: 749px)'), mqR = matchMedia('(prefers-reduced-motion: reduce)');
    var timer = 0, idx = 0, steps = 0, stopped = false, paused = false, raf = 0;
    var items = function () { return [].filter.call(list.children, function (li) { return getComputedStyle(li).display !== 'none'; }); };
    var guard = function () {
      bar.classList.remove('is-tight');
      var a = list.querySelector('.is-active');
      if (mqM.matches && a && a.scrollWidth > a.clientWidth + 1) bar.classList.add('is-tight');
    };
    var show = function (i) {
      var its = items(); if (!its.length) return;
      idx = ((i % its.length) + its.length) % its.length;
      [].forEach.call(list.children, function (li) { li.classList.toggle('is-active', li === its[idx]); });
      guard();
    };
    var tick = function () {
      if (paused || document.hidden) return;
      steps++;
      if (steps >= items().length * 3) { stopped = true; clearInterval(timer); timer = 0; show(0); return; }
      show(idx + 1);
    };
    var start = function () {
      clearInterval(timer); timer = 0;
      if (!mqM.matches || mqR.matches || stopped) { if (!stopped) show(0); return; }
      timer = setInterval(tick, 4500);
    };
    var userStop = function () { if (stopped) return; stopped = true; clearInterval(timer); timer = 0; };
    bar.addEventListener('touchstart', userStop, { passive: true });
    bar.addEventListener('click', userStop);
    bar.addEventListener('focusin', userStop);
    bar.addEventListener('mouseenter', function () { paused = true; });
    bar.addEventListener('mouseleave', function () { paused = false; });

    var it1 = list.querySelector('[data-wl-reason="1"]'), it2 = list.querySelector('[data-wl-reason="2"]'), it3 = list.querySelector('[data-wl-reason="3"]');
    var rs = [it1, it2, it3].filter(Boolean), prim = rs[0] || null;
    var w = function (el) { return el.getBoundingClientRect().width; };
    var overflowing = function () { return inner.scrollWidth > inner.clientWidth + 1; };
    var fit = function () {
      raf = 0;
      if (mqM.matches) {
        bar.classList.remove('is-fitted', 'is-compact');
        rs.forEach(function (el) { el.hidden = false; el.classList.remove('is-short'); });
        return;
      }
      bar.classList.add('is-fitted');
      bar.classList.remove('is-compact');
      rs.forEach(function (el) { el.hidden = true; el.classList.remove('is-short'); });
      var ok1 = false;
      if (prim) {
        prim.hidden = false;
        var tries = prim.querySelector('.wl-tb__d, .wl-tb__short') ? [[0, 0], [0, 1], [1, 0], [1, 1]] : [[0, 0], [1, 0]];
        for (var t = 0; t < tries.length && !ok1; t++) {
          bar.classList.toggle('is-compact', !!tries[t][0]);
          prim.classList.toggle('is-short', !!tries[t][1]);
          ok1 = w(prim) <= w(list) + 0.5;
        }
        if (!ok1) { prim.hidden = true; prim.classList.remove('is-short'); bar.classList.remove('is-compact'); }
      }
      if (overflowing()) bar.classList.add('is-compact');
      var used = ok1 ? w(prim) : 0, avail = w(list);
      rs.forEach(function (el) {
        if (el === prim) return;
        el.hidden = false;
        var need = (used ? 28 : 0) + w(el);
        if (used + need <= avail + 0.5) used += need; else el.hidden = true;
      });
    };
    var refit = function () { if (!raf) raf = requestAnimationFrame(fit); };
    var onMq = function () { start(); refit(); };
    var init = function () {
      start(); fit();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(refit);
      window.addEventListener('resize', refit, { passive: true });
      document.addEventListener('wl:hours', function () { show(stopped ? 0 : idx); refit(); });
      [mqM, mqR].forEach(function (m) { if (m.addEventListener) m.addEventListener('change', onMq); else if (m.addListener) m.addListener(onMq); });
    };
    if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
    window.WL = window.WL || {};
    window.WL.topbar = { show: show, stop: userStop, fit: fit };
  } catch (e) {}
})();
